import React, { FC, MouseEvent, ReactNode, useCallback } from 'react';

import getNodeText from 'ia-react-core/~/utils/components/_getNodeText';
import getBaseUrl from '../../../utils/browser/getBaseUrl';
import Link from '../../navigation/Link';
import InternalLink from '../../navigation/InternalLink';
import ExternalLink from '../../navigation/ExternalLink';

import { StyledFooterLink } from './FooterLinks.styles';

export interface FooterStaticLinksProps {
  links: {
    url?: string;
    key?: string;
    text: ReactNode;
    target?: '_self' | '_blank' | '_parent' | '_top';
    onClick?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  }[];
}

const FooterStaticLinks: FC<FooterStaticLinksProps> = ({ links }) => {
  const testIsInternalLink = useCallback((linkUrl = '') => {
    const baseUrl = getBaseUrl();
    const fullLinkUrl = linkUrl.startsWith('http') ?
      linkUrl :
      `${document.location.origin}${linkUrl.startsWith('/') ? '' : '/'}${linkUrl}`;

    return fullLinkUrl.startsWith(baseUrl);
  }, []);

  return (
    <>
      {links.map(({ key, text, url, target, onClick }) => {
        const isInternal = testIsInternalLink(url);
        const asProps = (!url && onClick) ? { as: 'button' } : {};
        return (
          <StyledFooterLink key={key || getNodeText(text)}>
            {isInternal && (
              <InternalLink
                data-testid="FooterLinksLink"
                href={url}
                target={target}
                onClick={onClick}
                {...asProps}
              >
                {text}
              </InternalLink>
            )}
            {!isInternal && target !== '_blank' && (
              <Link
                data-testid="FooterLinksLink"
                href={url}
                target={target}
                onClick={onClick}
              >
                {text}
              </Link>
            )}
            {!isInternal && target === '_blank' && (
              <ExternalLink
                data-testid="FooterLinksLink"
                href={url}
                onClick={onClick}
              >
                {text}
              </ExternalLink>
            )}
          </StyledFooterLink>
        );
      })}
    </>
  );
};

export default FooterStaticLinks;
